import { render, staticRenderFns } from "./tabComp3.vue?vue&type=template&id=1c8198cc&scoped=true&"
import script from "./tabComp3.vue?vue&type=script&lang=js&"
export * from "./tabComp3.vue?vue&type=script&lang=js&"
import style0 from "./tabComp3.vue?vue&type=style&index=0&id=1c8198cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8198cc",
  null
  
)

export default component.exports